import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { KeycloakProfile } from 'keycloak-js';
import { KeycloakService } from 'keycloak-angular';
import { NavigationEnd, Router } from '@angular/router';
import { GatewayConnectionService } from './services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from './services/helper/global-helper';
import { RoleService } from './services/helper/role-handling-helper';
import { IconHelper } from './services/helper/icon-helper';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'Sennebogen Remote Diagnostics';
    public isLoggedIn = false;
    public userProfile: KeycloakProfile | null = null;
    pinned: boolean = false;
    private cookieMess = inject(MatSnackBar);
    private senTrackMess = inject(MatSnackBar);
    private previousUrl: string = '';
    private currentUrl: string = '';

    @ViewChild('sidenav') sidenav: any;
    @ViewChild('toolbar') toolbar: any;

    @HostListener('window:beforeunload', ['$event'])
    beforeunloadHandler(event:any) {
      this.apiGwConnection.disconnectFromGateway().subscribe();
      this.keycloak.logout();
    }

    constructor(private translate: TranslateService, private readonly keycloak: KeycloakService, private router: Router, private apiGwConnection: GatewayConnectionService, public global: GlobalService, private roleHandling: RoleService, public iconHelper: IconHelper) {
        this.translate.addLangs(['de', 'en']);
        this.translate.setDefaultLang('en');
        this.global.sidenav.subscribe({
          next: newValue => {this.pinned = newValue.pinned;}
        });
    }

    public async ngOnInit() {
        this.isLoggedIn = await this.keycloak.isLoggedIn();
        if (this.isLoggedIn) {
          this.userProfile = await this.keycloak.loadUserProfile();
          await this.setInformation(this.userProfile);
          if(this.roleHandling.isRole('Basic')) {
            this.apiGwConnection.registerUser().subscribe();
            // store previous url in global service
            this.router.events.subscribe(event => {
              if(event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
                this.global.setPreviousUrl(this.previousUrl);
              }
            });
          } else {
            if(this.roleHandling.isRole('Sennebogen')) {
              this.sidenav.open();
            }
            this.router.navigateByUrl("/denied");
          }
          let message = "";
          this.translate.stream("MESSAGES.SENTRACK").subscribe((res) => { message = res;});
          setTimeout(()=> {
            this.cookieMess.open(this.translate.instant('MESSAGES.COOKIE'), 'OK', {horizontalPosition: 'right', panelClass: 'cookie-snackbar', duration: 5000});
            if(!this.keycloak.getUserRoles().includes('SENtrack')) {
              this.senTrackMess.open(message, "OK", {verticalPosition: 'top'});
            }
          }, 1500);
        }
    }

    private setInformation(userProfile: KeycloakProfile): Promise<void> {
      return new Promise((resolve) => {
        this.setLanguage(this.userProfile);
        this.global.user.next({name: userProfile.firstName + ' ' + userProfile.lastName, roles: this.keycloak.getKeycloakInstance().realmAccess?.roles });
        resolve();
      });
    }

    private setLanguage(profile: any) {
      let lang = '';
      if(Array.isArray(profile.attributes?.['locale'])) {
        lang = profile.attributes?.['locale'][0] as string;
      }
      if(!this.translate.getLangs().includes(lang)) {
        lang = this.translate.getDefaultLang();
      }
      this.toolbar.setLanguage(lang);
      this.translate.use(lang);
    }
    
    public login() {
      this.keycloak.login();
    }
    
    public logout() {
      this.keycloak.logout();
    }

    public handleSidenav() {
      if(!this.pinned) {
        this.sidenav.close();
      }
    }
}
